import React from 'react';
import { XIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { comparisonRows, flow } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Comparison() {
  return <section aria-labelledby="compare-title" className="bg-cream" data-id="element-45" data-mp="1l6cq90quur10">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-46" data-mp="1pxugatrcb777">
        <SectionHeading id="compare-title" title="Why This Bundle Feels Different" intro="Stop rebuilding your outreach materials every time. Start with a library that’s already done." data-id="element-47" data-mp="1q077zymwgvxg" />

        <div className="mx-auto mt-14 grid max-w-4xl gap-5 md:grid-cols-2" data-id="element-48" data-mp="1zuh1xkrhq2aa">
          <div className="rounded-2xl p-7 ring-1 ring-cream-line" data-id="element-49" data-mp="23z6up0qur0qz">
            <h3 className="text-sm font-extrabold uppercase tracking-[0.12em] text-ink-mute" data-id="element-50" data-mp="28xi6hh0pjlbu">Starting from scratch</h3>
            <ul className="mt-6 space-y-5" data-id="element-51" data-mp="9kxm2wuh7ojx">
              {comparisonRows.map(r => <li key={r.without} className="flex min-h-[3rem] items-start gap-3 text-ink-soft" data-id="element-52" data-mp="ei5u44lwuc7g">
                  <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-ink-mute" aria-hidden="true" data-id="element-53" data-mp="1m0z23ym05mkp" />
                  {r.without}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl bg-white p-7 shadow-card ring-2 ring-coral/30" data-id="element-54" data-mp="1d7vq7ur09hs6">
            <h3 className="text-sm font-extrabold uppercase tracking-[0.12em] text-coral-deep" data-id="element-55" data-mp="189kk9v3tzrf8">With the Mega Bundle</h3>
            <ul className="mt-6 space-y-5" data-id="element-56" data-mp="24zutl26h7muu">
              {comparisonRows.map(r => <li key={r.with} className="flex min-h-[3rem] items-start gap-3 font-bold text-navy" data-id="element-57" data-mp="20xgb4j6pyp43">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-leaf-deep" strokeWidth={3} aria-hidden="true" data-id="element-58" data-mp="1vy3tccupg88d" />
                  {r.with}
                </li>)}
            </ul>
          </div>
        </div>

        <ol className="mt-14 flex flex-wrap items-center justify-center gap-x-4 gap-y-3" aria-label="Choose, print, cut, share" data-id="element-59" data-mp="kkj9w2bfu67b">
          {flow.map((f, i) => <li key={f} className="flex items-center gap-4" data-id="element-60" data-mp="h1anwj80dt1g" data-mpi={i}>
              {i > 0 && <ArrowRightIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-61" data-mp="gzzkwlme0pbe" />}
              <span className="font-display text-4xl text-navy sm:text-5xl" data-id="element-62" data-mp="lysy0cxrieb1">{f}</span>
            </li>)}
        </ol>
      </div>
    </section>;
}